import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import netcluesLogo from "../../Assets/netclues-logo.gif";

const FooterComponent = () => {
	useEffect(() => {
		const currentDate = new Date();
		let currentYear = new Intl.DateTimeFormat("en", {
			year: "numeric",
		}).format(currentDate);
		let currentMonth = new Intl.DateTimeFormat("en", {
			month: "short",
		}).format(currentDate);
		let currentDay = new Intl.DateTimeFormat("en", {
			day: "2-digit",
		}).format(currentDate);

		const updateDate = (className, days) => {
			currentDate.setDate(currentDate.getDate() - days);
			currentYear = new Intl.DateTimeFormat("en", {
				year: "numeric",
			}).format(currentDate);
			currentMonth = new Intl.DateTimeFormat("en", {
				month: "short",
			}).format(currentDate);
			currentDay = new Intl.DateTimeFormat("en", {
				day: "2-digit",
			}).format(currentDate);

			const currentDateLoop = document.getElementsByClassName(className);
			for (let i = 0; i < currentDateLoop.length; i++) {
				currentDateLoop[
					i
				].innerHTML = `${currentDay} ${currentMonth}, ${currentYear}`;
			}
		};

		updateDate("current-date", 0);
		updateDate("one", 2);
		updateDate("two", 2);
		updateDate("three", 4);
		updateDate("four", 3);
		updateDate("five", 2);
		updateDate("six", -3);
		updateDate("seven", 15);
		updateDate("eight", 50);
	}, []);

	return (
		<div className="text-center py-4 bg-white" id="kt_footer">
			{/* Copyright */}
			<p className="fs-6 mb-2">
				© {new Date().getFullYear()} Netclues Master. All Rights Reserved.
			</p>

			{/* Powered by Netclues */}
			<p className="text-muted fs-7 d-flex align-items-center justify-content-center mb-0">
				Powered by
				<Link
					to="https://netclues.ky"
					target="_blank"
					rel="noopener noreferrer"
					className="ms-2 d-inline-flex align-items-center"
				>
					<img src={netcluesLogo} alt="Netclues" title="Netclues" className="h-20px" />
				</Link>
			</p>
		</div>
	);
};

export default FooterComponent;
